import { Controller } from '@hotwired/stimulus';
import { Form } from '../shared/elements/forms';

export default class extends Controller {
    static get values() {
        return {
            formId: String,
            open: Boolean,
        }
    };

    static targets = [
        'ModalContainer',
        'FormContainer',
        'title',
        'description',
        'path',
        'duration',
    ];

    updateContent(event) {
        const {
            title = 'Beauty Logistics and Fulfillment: The Master Class',
            path = 'Learning Path',
            description = 'Self-paced learning designed for beauty brands ready to turn logistics into their competitive advantage',
            duration = '2.5 hours of self-paced courses and material',
        } = event.detail || {};

        this.titleTarget.innerHTML = title;
        this.pathTarget.innerHTML = path;
        this.descriptionTarget.innerHTML = description;
        this.durationTarget.innerHTML = duration;
    }

    open() {
        this.openValue = true;
        this.ModalContainerTarget.classList.remove('blog-quote-cta-modal--initial');
        this.ModalContainerTarget.classList.remove('blog-quote-cta-modal--close');
        this.ModalContainerTarget.classList.add('blog-quote-cta-modal--open');

        return Form({
            form_id: this.formIdValue,
        }, this.FormContainerTarget)
            .catch((err) => console.error(err));
    }

    close() {
        this.openValue = false;
        this.ModalContainerTarget.classList.remove('blog-quote-cta-modal--open');
        this.ModalContainerTarget.classList.add('blog-quote-cta-modal--close');
        this.FormContainerTarget.innerHTML = '';
    }

    toggleModal() {
        if (this.openValue) {
            this.open();
        } else {
            this.close();
        }
    }
}
